/* eslint-disable no-unused-vars */
import { QuotationFormStepTypes } from "constants/";

export type QuotationFormState = {
  service: any;
  costs: any;
  schedule: any;
  misc: any;
  draftSaved: Record<string, boolean>;
  unsavedChanges: Record<string, boolean>;
  disabledFields: any;
};

export const initialState: QuotationFormState = {
  service: {},
  costs: {
    totalAmount: 0,
  },
  schedule: {},
  misc: {},
  draftSaved: {
    [QuotationFormStepTypes.SERVICE]: false,
  },
  unsavedChanges: {
    [QuotationFormStepTypes.COSTS]: false,
    [QuotationFormStepTypes.SCHEDULE]: false,
    [QuotationFormStepTypes.MISC]: false,
  },
  disabledFields: {},
};

export enum QuotationFormActionType {
  UPDATE_DRAFT_SAVE = "UPDATE_DRAFT_SAVE",
  UPDATE_TOTAL_AMOUNT = "UPDATE_TOTAL_AMOUNT",
}

export type QuotationFormAction = {
  payload: any;
  type: QuotationFormActionType;
};

export const reducer = (state: QuotationFormState, action: QuotationFormAction) => {
  switch (action.type) {
    case QuotationFormActionType.UPDATE_DRAFT_SAVE:
      return {
        ...state,
        draftSaved: {
          ...state.draftSaved,
          [action.payload.key]: action.payload.value,
        },
      };
    case QuotationFormActionType.UPDATE_TOTAL_AMOUNT:
      return {
        ...state,
        costs: {
          ...state.costs,
          totalAmount: action.payload,
        },
      };
    default:
      throw new Error();
  }
};
